/* eslint-disable no-underscore-dangle */

import React from 'react';
import PropTypes from 'prop-types';

import { getResourcePath } from '@spotahome/soyuz/client';
import { AppModal as AppModalComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/AppModal/AppModal.css';

const PATH_MODAL_IMAGE_MOBILE = '/images/app_illustration.png';

const buildDeeplink = (slug = '') => {
  const sessionId =
    typeof window !== 'undefined' && window.__CONTEXT__
      ? window.__CONTEXT__.__EXPERIMENTS_SESSION_ID__
      : '';
  return `https://spotahome.app.link/${slug}${sessionId &&
    `?webSessionId=${sessionId}`}`;
};

const AppModal = ({ origin }) => (
  <AppModalComponent
    buttonLink={buildDeeplink(
      (origin === 'search' && 'fullmodal_search') ||
        (origin === 'listing' && 'fullmodal_listing') ||
        'fullmodal'
    )}
    image={getResourcePath(PATH_MODAL_IMAGE_MOBILE)}
  />
);

AppModal.propTypes = {
  origin: PropTypes.oneOf(['search', 'listing'])
};
AppModal.defaultProps = {
  origin: 'search'
};

export default AppModal;
